import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-applications',
  templateUrl: './client-applications.component.html',
  styleUrls: ['./client-applications.component.scss']
})
export class ClientApplicationsComponent implements OnInit {

  applications: ApplicationInfo[] = [
    {
      name: 'Notepad++',
      description: 'File Explorer',
      // icon: '../../../../../assets/images/client/Notepad++_2023.svg',
      icon: '../../../../../assets/images/client/Notepad++_2023.svg',
      version: '2023',
      disabled: false,
      toShow: true
    },
    {
      name: 'Visual Studio',
      description: 'Terminal',
      icon: '../../../../../assets/images/client/Visual_Studio_2019.svg',
      version: '2023',
      disabled: false,
      toShow: true
    }
  ]

  constructor() { }

  ngOnInit(): void {
  }

  openApplicationSession(application: ApplicationInfo) {
  }
}

interface ApplicationInfo {
  name: string;
  description: string;
  icon: string;
  version: string;
  disabled: boolean;
  toShow: boolean;
}
